import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LeasingTransactionsWithAMLRoutes } from '../../../routes';

export const LeasingTransactionsWithAMLLayout = () => <SwitchRoute routes={LeasingTransactionsWithAMLRoutes} />;
